import { Body14Regular } from "@/components/typography/Body14Regular";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerOrderDetailReceiverTable: React.FC<Props> = ({
  orderDetail,
}) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell
                colSpan={2}
                className={`${headCellStyle} w-[112px] p-0 h-[46px]`}
              >
                <CustomCell className="flex items-center justify-center mx-[16px] my-[12px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    배송지 1
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    운송장 번호
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell className="h-fit flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    {orderDetail.noSong && orderDetail.cdDlvShopName && (
                      <Body14Regular className="text-semantic-text-body max-w-[1000px]">
                        {orderDetail.cdDlvShopName} {orderDetail.noSong}
                      </Body14Regular>
                    )}
                    <span
                      className={
                        orderDetail.shippingMemo
                          ? "text-xs text-blue-600"
                          : "text-xs text-gray-400"
                      }
                    >
                      {orderDetail.shippingMemo
                        ? orderDetail.shippingMemo.slice(0, 50)
                        : "배송 메모 없음"}
                    </span>
                  </div>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    배송 상품
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell className="h-fit">
                  <Body14Regular className="text-semantic-text-body max-w-[1000px] whitespace-break-spaces">
                    {orderDetail.cartItems.map((item) => item.name).join(", ")}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    받는 사람
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    주소
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverPostalCode}{" "}
                    {orderDetail.receiverAddress}{" "}
                    {orderDetail.receiverAddressDetail}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    연락처
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverPhone}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className=" border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    배송 요청
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverMemo}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
